/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ pct: NonNullable<unknown>, complete: NonNullable<unknown>, unlocked: NonNullable<unknown> }} Attribute_Task_CompletenessInputs */

const en_attribute_task_completeness = /** @type {(inputs: Attribute_Task_CompletenessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.pct}% · ${i?.complete} of ${i?.unlocked}`)
};

/**
* | output |
* | --- |
* | "{pct}% · {complete} of {unlocked}" |
*
* @param {Attribute_Task_CompletenessInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_task_completeness = /** @type {((inputs: Attribute_Task_CompletenessInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Task_CompletenessInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_task_completeness(inputs)
});